module.exports = __webpack_public_path__ + "img/emoji-accommodation@3x.235a526.png";